<form #am="ngForm" style="width:100%;">
  <div class="assessmentMessage edit-panel__add-attachments-holder">
    <h5 class="edit-panel__add-attachments-title">Assessment message</h5>

    <ul class="edit-panel__list">
      <li class="edit-panel__item">
        <mat-form-field class="edit-panel__material-holder">
          <input type="text" matInput [(ngModel)]="assessmentMessage!.title" name="title" id="title" required
                 placeholder="Title" />
        </mat-form-field>
      </li>
      <li class="edit-panel__item">
        <mat-form-field class="edit-panel__material-holder">
          <input matInput type="text" [(ngModel)]="assessmentMessage!.linkToImage" name="linkToImage" id="linkToImage"
                 placeholder="Link to PDF page" />
        </mat-form-field>
      </li>
      <li class="edit-panel__item center">
        <input type="button" value="Done" (click)="add()" [disabled]="!am.valid" class="edit-panel__link button--done blue" />
      </li>
    </ul>
  </div>
</form>
